module.exports = __webpack_public_path__ + "static/media/banner-image.7b8a0bec.png";